import { createSelector } from 'reselect';

import { RootState } from '../../reducers';

// todo: zmenit potom na product, zatial je to zle zaradene
const selectState = (state: RootState) => state.category;

const selectProductFetching = createSelector(selectState, (select) => select.fetchCategory === 'FETCH');

const selectProductsInputFilter = createSelector(selectState, (select) => {
	return select.filter.input;
});

const selectProductsInputSection = createSelector(selectState, (select) => {
	return select.filter.modalActiveSection;
});
const selectProductsInputCategory = createSelector(selectState, (select) => {
	return select.filter.modalActiveCategory;
});

const selectProductsTree = createSelector(selectState, (select) => {
	return select.productTree;
});

const selectActiveProductMenuItem = createSelector(selectState, (select) => select.activeItem);

const selectProductSections = createSelector(selectProductsTree, (select) => {
	// debugger
	return select?.flatMap((item) => item.section);
});

const selectFilteredAllProducts = createSelector(selectState, selectProductsInputSection, selectProductsInputCategory, (select, section, category) => {
	const products = select.allProducts;
	if (section.length === 0 && category.length === 0) {
		return products;
	}

	return products?.filter((p) => {
		if (section.length > 0) {
			return p.section && section.includes(p.section.code);
		}
		if (category.length > 0) {
			return p.category && category.includes(p.category.code);
		}
	});
});

export {
	selectProductFetching,
	selectProductsInputFilter,
	selectProductsTree,
	selectActiveProductMenuItem,
	selectFilteredAllProducts,
	selectProductSections,
	selectProductsInputSection,
	selectProductsInputCategory,
};
